import React, { useState } from "react";
import { textMapping } from "../utils/helper";

const TermsPopup = ({ popupclose }) => {
  return (
    <>
      <div className="popup_bg">
        <div className="terms_pos">
          <div className="terms_content">
            <h3 className="terms_head">
              {textMapping("Terms and Conditions")}
            </h3>
            <div className="tems_detail">
              <p>
                "
                {textMapping(
                  "You must tick the box to continue, as it is mandatory."
                )}
                "
              </p>
              <button className="get_btn" onClick={popupclose}>
                {textMapping("Okay, Got it")}
                <img
                  src="/assets/images/arrownext.svg"
                  className="active_arrow"
                  alt=""
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsPopup;
